import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ClickElsewhereDirective } from './click-elsewhere.directive';
import { LabelModule } from '@progress/kendo-angular-label';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PagerModule } from '@progress/kendo-angular-pager';
import { ExpensesService } from '@api-reports-client';
import { reportsServiceProvider } from '@app/shared/service-providers';

import { ExpensesRoutingModule } from './expenses-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { ExpensesListComponent } from './expenses-list/expenses-list.component';
import { ExpenseViewComponent } from './expense-view/expense-view.component';
import { ExpenseEditComponent } from './expense-edit/expense-edit.component';
import { 
  ExpenseGridModule,
  ExpensesEditableGridModule,
  ExpenseAddDrawerComponent,
  ExpenseLinkDrawerComponent
} from './shared/components';
import { ExpenseAddComponent } from './expense-add/expense-add.component';

const SHARED_MODULES = [
  ExpenseGridModule,
  ExpensesEditableGridModule
];

@NgModule({
  declarations: [
    // ClickElsewhereDirective,
    ExpenseAddComponent,
    ExpenseAddDrawerComponent,
    ExpenseLinkDrawerComponent,
    
    ExpenseViewComponent,
    ExpenseEditComponent,
    ExpensesListComponent,
    ExpenseViewComponent,
    ExpenseEditComponent
  ],
  imports: [
    CommonModule,
    ExpensesRoutingModule,
    SharedModule,
    InputsModule,
    ButtonsModule,
    LayoutModule,
    GridModule,
    PagerModule,
    DropDownsModule,
    FormsModule,
    ReactiveFormsModule,
    LabelModule,
    DateInputsModule,

    ...SHARED_MODULES
  ],
  providers: [
    ...reportsServiceProvider([ExpensesService])
  ]
})
export class ExpensesModule {}
